import BusinessOrders from "../BusinessOrders";

const SHIPPING_STATUSES = ["Ready for Dispatch", "Shipped", "Out for Delivery", "Delivered", "Failed Delivery"];

export default function OrdersShipping() {
  return (
    <BusinessOrders
      pageTitle="Orders Shipping"
      pageSubtitle="Track packed orders, shipment handoff, and in-flight delivery completion from a dedicated shipping queue."
      panelTitle="Shipping Queue"
      initialStatus="All"
      allowedStatuses={SHIPPING_STATUSES}
      openWorkMode="shipping"
    />
  );
}
